module.exports = __webpack_public_path__ + "e3e4f80d18f7c56967237e2fb04aa97c.svg";